import InitiativeBar from "@/tabletop/tokens/InitiativeBar.tsx";
import AreaEffectOptions from "@/tabletop/effects/AreaEffectOptions.tsx";
import LevelTransitionDialog from "./LevelTransitionDialog.tsx";
import GameMasterMapPopovers from "./GameMasterMapPopovers.tsx";
import type {GameMasterMapModel} from "./useGameMasterMapModel.ts";
export default function GameMasterMapOverlays({model}: {model: GameMasterMapModel}) {
    const {friendlyVisibility, showAnnotations, selection, annotations, closeMapPopovers, activeLevel,
        levelTransition, toggledLightLocks, toggleLightLock, mapSize} = model;
    return <>
        <InitiativeBar visibility={friendlyVisibility}/>
        <GameMasterMapPopovers activeLevel={activeLevel} selection={selection}
            toggledLightLocks={toggledLightLocks} onToggleLightLock={toggleLightLock}
            annotations={annotations} showAnnotations={showAnnotations}
            viewport={mapSize} onCloseAnnotation={closeMapPopovers}/>
        <AreaEffectOptions viewport={mapSize}/>
        {levelTransition.pending && <LevelTransitionDialog transition={levelTransition.pending.transition}
            targetLevel={levelTransition.targetLevel} tokenCount={levelTransition.selectedForTransition.length}
            ready={levelTransition.ready} busy={levelTransition.busy}
            onClose={levelTransition.close} onConfirm={() => void levelTransition.confirm()}/>}
    </>;
}
